export const UNITS_STATE_TOKEN = 'UNITS';

export const UNITS_API_PATHS = {
    units: 'client/units',
    teams: 'client/teams',
    addFavorite: 'add_favorite',
    removeFavorite: 'remove_favorite'
};
